import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { merchantThemes } from '../../Variable'

export const TextareaWrapperStyle = styled.label`
	display: flex;
	flex-flow: row wrap;
	align-content: flex-start;
	align-items: flex-start;
	justify-content: space-between;
	position: relative;
	width: 100%;
	margin-bottom: ${rem(40)};
`
export const Error = styled.div`
	padding-top: ${rem(3)};
	font-size: ${rem(12)};
	line-height: 1;
	color: ${({ theme }) => theme.color.redOne};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-size: ${rem(15)};
		`}
`
export const TextareaStyle = styled.textarea`
	border: ${rem(1)} solid ${({ theme }) => theme.color.blackOne};
	background: ${({ theme }) => theme.color.grayFive};
	min-height: ${rem(120)};
	border-radius: ${rem(3)};
	padding: ${rem(10)};
	font-size: ${rem(16)};
	font-family: Arial;
	display: block;
	width: 100%;
	resize: none;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-size: ${rem(15)};
			border-radius: ${rem(10)};
			background: transparent;
		`}

	&::placeholder {
		font-size: ${rem(16)};
		line-height: ${rem(18)};

		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				font-size: ${rem(15)};
			`}
	}

	&:hover {
	}
	&:focus {
	}
	&:disabled {
	}
	${(props) =>
		props.error &&
		css`
			&::placeholder {
			}
		`}
`
